import { Box, HStack, Link, Text } from '@betterment/samba-react';

const FOOTER_URLS = {
  legalPolicyUrl: 'https://www.betterment.com/401k/legal/',
  privacyPolicyUrl: 'https://www.betterment.com/legal/privacy-policy',
  bettermentUrl: 'https://www.betterment.com/',
  bettermentSecuritiesUrl: 'https://www.bettermentsecurities.com/',
  finraUrl: 'http://www.finra.org/',
  sipcUrl: 'http://www.sipc.org/',
  companyDescriptionUrl: 'https://www.betterment.com/legal/company-description/',
} as const;

const OFFICE_ADDRESS = '29 W 46th Street, 7th Floor, New York, NY, 10036';

const Footer = () => {
  return (
    <Box
      role="contentinfo"
      css={{
        color: 'text.placeholder',
        p: 'space.400',
        w: '100%',
        '& p': {
          marginBottom: 'space.200',
          textStyle: 'text50',
          '&:last-of-type': {
            marginBottom: 0,
          },
        },
      }}
    >
      <HStack
        css={{
          flexDirection: { base: 'column', md: 'row' },
          gap: 'space.300',
          maxWidth: 'container.max',
          mx: 'auto',
        }}
      >
        <Box css={{ flexGrow: 1 }}>
          <Text as="p">
            This website is operated and maintained by Betterment for Business LLC.{' '}
            <Link variant="textSecondary" href={FOOTER_URLS.legalPolicyUrl} target="_blank">
              Terms & Legal
            </Link>{' '}
            <Link variant="textSecondary" href={FOOTER_URLS.privacyPolicyUrl} target="_blank">
              Privacy Policy
            </Link>
          </Text>
          <Text as="p">
            Unless otherwise specified, all return figures shown above are for illustrative purposes only, and are not
            actual customer or model returns. Actual returns will vary greatly and depend on personal and market
            circumstances.
          </Text>
        </Box>
        <Box css={{ flexGrow: 2 }}>
          <Text as="p">
            401(k) plan administration services provided by Betterment for Business LLC. Investment advice to plans and
            plan participants provided by{' '}
            <Link variant="textSecondary" href={FOOTER_URLS.bettermentUrl} target="_blank">
              Betterment LLC
            </Link>
            , an SEC registered investment adviser. Brokerage services provided to clients of Betterment LLC by{' '}
            <Link variant="textSecondary" href={FOOTER_URLS.bettermentSecuritiesUrl} target="_blank">
              Betterment Securities
            </Link>
            , an SEC registered broker-dealer and member of{' '}
            <Link variant="textSecondary" href={FOOTER_URLS.finraUrl} target="_blank">
              FINRA
            </Link>
            /
            <Link variant="textSecondary" href={FOOTER_URLS.sipcUrl} target="_blank">
              SIPC
            </Link>
            . Betterment LLC and Betterment Securities are affiliates of Betterment for Business LLC.
          </Text>
          <Text as="p">
            Investments: Not FDIC Insured &bull; No Bank Guarantee &bull; May Lose Value. Investing in securities
            involves risks, and there is always the potential of losing money when you invest in securities. Before
            investing, consider your investment objectives and Betterment's charges and expenses. Past performance does
            not guarantee future results, and the likelihood of investment outcomes are hypothetical in nature. See full
            disclosures for more information. Not an offer, solicitation of an offer, or advice to buy or sell
            securities in jurisdictions where Betterment Securities is not registered.
          </Text>
          <Text as="p">Contact: {OFFICE_ADDRESS}.</Text>
        </Box>
        <Box css={{ flexGrow: 1 }}>
          <Text as="p">
            Any links provided to other websites are offered as a matter of convenience and are not intended to imply
            that Betterment or its authors endorse, sponsor, promote, and/or are affiliated with the owners of or
            participants in those sites, or endorses any information contained on those sites, unless expressly stated
            otherwise.
          </Text>
          <Text as="p">
            <Link variant="textSecondary" href={FOOTER_URLS.companyDescriptionUrl} target="_blank">
              See how we determine
            </Link>{' '}
            the largest independent online financial advisor.
          </Text>
          <Text as="p">
            The information provided by Betterment Support is educational only and is not investment or tax advice.
          </Text>
          <Text as="p">&copy; Betterment Holdings Inc.</Text>
        </Box>
      </HStack>
    </Box>
  );
};

export default Footer;
